/**
 * Filter for results from Places API
 */

export function getAutoCompleteState(array) {
  const placeType = 'administrative_area_level_1';
  return getAutoCompleteValueByType(array, placeType);
}

export function getAutoCompleteZipCode(array) {
  const placeType = 'postal_code';
  return getAutoCompleteValueByType(array, placeType);
}

export function getAutoCompleteCity(array) {
  const placeType = 'locality';
  return getAutoCompleteValueByType(array, placeType);
}

export function getAutoCompleteStreetNumber(array) {
  const placeType = 'street_number';
  return getAutoCompleteValueByType(array, placeType);
}

export function getAutoCompleteStreetName(array) {
  const placeType = 'route';
  return getAutoCompleteValueByType(array, placeType);
}

export function getAutoCompleteValueByType(array, placeType) {
  const found = array.filter(item=>item.types && item.types[0]===placeType);

  return (found[0] && found[0].short_name) || '';
}